import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class NonSCAStoreStaffCardsService {
  isNonScaLoginJourney: BehaviorSubject<boolean>;
  username: BehaviorSubject<string>;

  constructor() {
    this.isNonScaLoginJourney = new BehaviorSubject<boolean>(false);
    this.username = new BehaviorSubject('');
  }

  notifyIsNonScaLoginJourneyObservers() {
    this.isNonScaLoginJourney.next(true);
  }

  setUsername(username: string) {
    this.username.next(username);
  }
}
